import type { OrganizationListItem } from '../../types/organization';
import './OrganizationCard.css';

interface OrganizationCardProps {
  organization: OrganizationListItem;
  onClick: () => void;
}

const roleColors: Record<string, string> = {
  owner: '#7c3aed',
  admin: '#2563eb',
  member: '#059669',
  viewer: '#6b7280',
};

export function OrganizationCard({ organization, onClick }: OrganizationCardProps) {
  const initial = organization.name.charAt(0).toUpperCase();

  return (
    <button className="org-card" onClick={onClick} type="button">
      <div className="org-card__logo">
        {organization.logo_url ? (
          <img src={organization.logo_url} alt={organization.name} />
        ) : (
          <span className="org-card__initial">{initial}</span>
        )}
      </div>
      <div className="org-card__content">
        <h3 className="org-card__name">{organization.name}</h3>
        <span className="org-card__slug">/{organization.slug}</span>
      </div>
      <span
        className="org-card__role"
        style={{ backgroundColor: roleColors[organization.role] }}
      >
        {organization.role}
      </span>
    </button>
  );
}
